import React, { useState } from 'react'
import { useCookies } from "react-cookie"

const Modal = ({ mode, setShowModal, getData, task }) => {
    const [cookies, setCookie, removeCookies] = useCookies(null)
    const editMode = mode === "edit" ? true : false
    const serverUrl = process.env.REACT_APP_TODO_SERVER_URL || "http://localhost:8000"

    const [data, setData] = useState({
        user_email: editMode ? task.user_email : cookies.Email,
        title: editMode ? task.title : "",
        progress: editMode ? task.progress : 50,
        date: editMode ? task.date : new Date()
    })

    const postData = async (e) => {
        e.preventDefault()
        try {
            const response = await fetch(`${serverUrl}/todos`, {
                method: "POST",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            })
            if (response.status === 200) {
                console.log("Worked")
                setShowModal(false)
                getData()
            }

        } catch (error) {
            console.error(error);
        }
    }



    const editData = async (e) => {
        e.preventDefault()
        try {
            const response = await fetch(`${serverUrl}/todos/${task.id}`, {
                method: "PUT",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            })
            if (response.status === 200) {
                setShowModal(false)
                getData()
            }
        } catch (err) {
            console.error(err);
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target

        setData(data => ({
            ...data,
            [name]: value
        }))

        console.log(data)
    }
    return (
        <div className='overlay'>
            <div className="modal">
                <div className='form-title-container'>
                    <h3>Let's {mode} your task</h3>
                    <button onClick={() => setShowModal(false)}>X</button>
                </div>

                <form>
                    <input
                        required
                        maxLength={30}
                        placeholder=' Your task goes here'
                        name='title'
                        value={data.title}
                        onChange={handleChange}
                    />
                    <br />
                    <label htmlFor="range">Drag to select your current progress</label>
                    <input
                        className='pro'
                        type='range'
                        required
                        id='range'
                        min='0'
                        max='100'
                        name='progress'
                        value={data.progress}
                        onChange={handleChange}
                    />
                    <p>Current Progress: {data.progress}%</p>
                    <input className={mode} type='submit' onClick={editMode ? editData : postData} />
                </form>
            </div>
        </div>
    )
}

export default Modal